export default {
  data() {
    return {
      ambientes: [],
    };
  },
  methods: {
    async getAmbientes() {
      const { data } = await this.$http.get('fiscal.get-ambiente');
      this.ambientes = data;
    },
  },
};
